import { useNavigate, useSearchParams } from "react-router-dom"
import { useEffect, useState } from "react";

// components
import LoaderFull from "../components/LoaderFull";
import PageLayout from "../components/PageLayout"

// services
import axiosInstance from "../api/apiClient";

// icons
import IconComponent from "../components/Icon";
import { FaBook, FaCheck, FaBookReader } from "react-icons/fa";
import { BsArrowLeft, BsFillBookmarkFill } from "react-icons/bs";
import { FiInfo } from "react-icons/fi";

// constants
import { book, shelves } from "../assets/data/constants";
import Book from "../components/Book";

const noCover = 'https://dryofg8nmyqjw.cloudfront.net/images/no-cover.png';

const StatDetails = () => {
      const [searchParams] = useSearchParams();
      const [library, setLibrary] = useState([]);
      const [books, setBooks] = useState<any[]>([]);
      const [headerText, setHeaderText] = useState('');
      const [underText, setUnderText] = useState<string | undefined>();
      const [imgUrl, setImgUrl] = useState<string | undefined>();
      const navigate = useNavigate();

      const type = searchParams.get('type');
      const value = searchParams.get('value');
 

    const getBooksByType = async () => {
        let booksToShow: any = [];
        if (type === 'authors-read') {
            booksToShow = library.filter((book: any) => book['Read Count'] > 0 && book['Author'] === value);
            setHeaderText('Books read by ' + value + ' (' + booksToShow.length + ')');
        } else if (type === 'rating') {
            booksToShow = library.filter((book: any) => Math.round(book['My Rating']).toString() === value);
            setHeaderText('My ' + value + '⭐️ books (' + booksToShow.length + ')');
        } else if (type === 'authors-library') {
            booksToShow = library.filter((book: book) => book['Author'] === value).sort((a: any, b: any) => a['Original Publication Year'] - b['Original Publication Year']);
            const authorInfo = await fetch(`https://nl.wikipedia.org/api/rest_v1/page/summary/${value?.replace(/ /g,"_")}`).then((res) => res.json());
            if (authorInfo?.extract?.includes('schrijver') || authorInfo?.extract?.includes('schrijfster') || authorInfo?.extract?.includes('auteur')) {
                setUnderText(authorInfo.extract);
                setImgUrl(authorInfo.thumbnail?.source);
            }
            setHeaderText('Books by ' + value + ' (' + booksToShow.length + ')');
        } else if (type === 'exclusive-shelf') {
            booksToShow = library.filter((book: any) => book['Exclusive Shelf'] === value);
            setHeaderText('Books with status: ' + shelves.find((shelf) => shelf.value === value)?.name + ' (' + booksToShow.length + ')');
        } else if (type === 'serie') {
            booksToShow = library.filter((book: any) => book['Serie Id']?.toString() === value?.toString());
            booksToShow.sort((a: any, b: any) => a['Serie Position'] - b['Serie Position']);
            setHeaderText('Books in serie: ' + booksToShow[0]?.['Serie'] + ' (' + booksToShow.length + ')')
        }
        setBooks(booksToShow);
    }

       useEffect(() => {
        if (!type || !value) {
            navigate(-1);
        }
        axiosInstance.get('/getAllBooks').then((data:any) => {
            setLibrary(data);
        });
    }, []);
    
    useEffect(() => {
        getBooksByType();
    }, [library]);

    if (library.length === 0) {
        return <LoaderFull/>
    }

    return (
        <PageLayout
            type="stats"
            headerText={headerText}
            text={underText}
            image={imgUrl}
        >
                <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20 mt-[40px]">
                    <button className="flex items-center gap-2" onClick={() => navigate(-1)}>
                        <IconComponent icon={BsArrowLeft} width={30} color="#60637A" className="drop-shadow-xl" />
                        <p className="text-[#60637A]">Back</p>
                    </button>
                    <div className="grid grid-cols-2 md:grid-cols-6 gap-4 mt-[40px]">
                        {books.map((book: book, key: any) => {
                            return (
                                <Book book={book} key={key} />
                            )
                        })}
                </div>
            </div>

        </PageLayout>
    )
}

export default StatDetails